//
//
//
//
//
//

    import fixedInput from './utils/fixedInput'
export default {
  name: 'app',
    mixins: [fixedInput],
    updated() {
        // 解决ios输入框弹出的页面样式问题
        document.querySelectorAll("input").forEach(item => {
            item.onblur = this.temporaryRepair;
        });
        document.querySelectorAll("select").forEach(item => {
            item.onchange = this.temporaryRepair;
        });
        document.querySelectorAll("textarea").forEach(item => {
            item.onblur = this.temporaryRepair;
        });
    },
    created(){
    // window.sessionStorage.clear();
    // window.localStorage.clear();
    }
}



// WEBPACK FOOTER //
// ./src/App.vue